<template>
  <v-container fluid>
    <v-row justify="center" align="center" class="mt-md-5 pa-2 pa-md-5">
      <v-col cols="12" md="10">
        <v-card elevation="10" class="rounded-lg">
          <v-card-title class="bg-indigo-darken-4 white--text d-flex align-center py-4">
            <v-icon class="mr-2" color="white">mdi-account-plus</v-icon>
            Alumni Register
          </v-card-title>

          <div class="pa-4 pa-md-6">
            <!-- <v-row dense>
              <v-col cols="12" md="2">
                <v-select
                  disabled="true"
                  :rules="RequireRules"
                  v-model="form.prefix"
                  variant="outlined"
                  label="คำนำหน้า"
                  :items="prefixes"
                ></v-select>
                <v-text-field
                  v-if="checkPrefix()"
                  v-model="otherPrefix"
                  variant="outlined"
                  label="ระบุคำนำหน้า"
                  hide-details="auto"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="7">
                <v-text-field
                  :rules="RequireRules"
                  v-model="form.fullName"
                  variant="outlined"
                  label="ชื่อ-นามสกุล"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="6" md="3">
                <v-number-input
                  :disabled="!reqPaymentFile"
                  v-model="form.generation"
                  control-variant="hidden"
                  label="ปีที่จบการศึกษา (พศ.)"
                  variant="outlined"
                  hide-details="auto"
                  persistent-placeholder="true"
                  placeholder="25XX"
                ></v-number-input>
              </v-col>
            </v-row> -->
            <v-row dense>
              <v-col cols="12" md="4">
                <v-text-field :rules="RequireRules" v-model="searchQuery.fname" variant="outlined"
                  label="ชื่อจริง(ระหว่างศึกษา)" hide-details="auto"></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field :rules="RequireRules" v-model="searchQuery.lname" variant="outlined"
                  label="นามสกุล(ระหว่างศึกษา)" hide-details="auto"></v-text-field>
              </v-col>
              <v-col cols="12" md="2" align-self="center">
                <v-btn :disabled="!canSearch" prepend-icon="mdi-card-search" variant="outlined" color="blue"
                  @click="checkName">
                  ค้นหา
                </v-btn>
              </v-col>
              <v-col cols="12" md="1" align-self="center">
                <v-btn :disabled="!form.studentNum" prepend-icon="mdi-file-edit" variant="outlined" color="warning"
                  @click="clearSearch">
                  แก้ไข
                </v-btn>
              </v-col>
              <v-col cols="12" md="2">
                <!-- <v-select
                  disabled="true"
                  :rules="RequireRules"
                  v-model="form.prefix"
                  variant="outlined"
                  label="คำนำหน้า"
                  :items="prefixes"
                ></v-select> -->
                <!-- <v-text-field
                  v-if="checkPrefix()"
                  v-model="otherPrefix"
                  variant="outlined"
                  label="ชื่อจริง(ระหว่างศึกษา)"
                  hide-details="auto"
                >
                </v-text-field> -->
              </v-col>
            </v-row>

            <v-row  dense class="my-3">
              <v-divider class="my-6 border-opacity-50"> ผลการค้นหา</v-divider>
              <v-col cols="12" md="3">

                <v-text-field :disabled="true" :rules="RequireRules" readonly="true" v-model="form.studentNum" variant="outlined"
                  label="รหัสนักศึกษา" hide-details="auto" </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field :rules="RequireRules" v-if="form.firstName" readonly="true" v-model="form.firstName"
                  variant="outlined" label="ชื่อ" hide-details="auto" </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field :rules="RequireRules" v-if="form.lastName" readonly="true" v-model="form.lastName"
                  variant="outlined" label="นามสกุล" hide-details="auto" </v-text-field>
              </v-col>
            </v-row>

            <v-row dense class="mt-2">
              <v-col cols="6" md="3">
                <v-date-input :rules="RequireRules" v-model="form.birthday" label="วันเกิด (วว/ดด/ค.ศ.)" prepend-icon=""
                  variant="outlined" persistent-placeholder :display-format="customFormat"></v-date-input>
              </v-col>
              <v-col cols="6" md="4">
                <v-text-field type="number" :rules="RequireRules" v-model="form.phone" label="เบอร์โทร"
                  variant="outlined" @blur="phoneAlert = phoneAlertMessage(form.phone)"></v-text-field>
              </v-col>
              <v-chip color="pink" variant="tonal" class="mt-1 text-black">
                {{
                  phoneAlert
                    ? phoneAlert
                    : " เบอร์โทรจะเป็นรหัสผ่านในการตรวจสอบสถานะ"
                }}
              </v-chip>
            </v-row>
            <v-row dense class="mt-2">
              <v-col cols="6" md="4">
                <v-text-field type="email" :rules="emailRule" v-model="form.contact_email" label="email ที่ติดต่อได้"
                  variant="outlined"></v-text-field>
              </v-col>
              <v-col cols="6" md="4">
                <v-text-field type="text" :rules="RequireRules" v-model="form.LineId" label="Line ID"
                  variant="outlined"></v-text-field>
              </v-col>
            </v-row>

            <v-row dense class="mt-2">
              <v-col cols="6" md="3" align-self-start>
                <v-checkbox class="justify-start-checkbox" v-model="changeName" color="red"
                  label="มีการเปลี่ยนชื่อหรือนามสกุล" value="true" hide-details></v-checkbox>
              </v-col>
              <v-col cols="6" md="4">
                <v-text-field :disabled="!changeName" type="text" v-model="form.newName" label="ชื่อ-นามสกุลใหม่"
                  variant="outlined"></v-text-field>
              </v-col>
            </v-row>
            <v-divider class="my-6 border-opacity-50"></v-divider>

            <h3 class="text-subtitle-1 mb-4 font-weight-bold text-indigo-darken-4">
              <v-icon start size="small">mdi-map-marker</v-icon> ที่อยู่ปัจจุบัน
            </h3>

            <v-row dense>
              <v-col cols="12" md="6">
                <v-textarea :rules="RequireRules" v-model="form.addressDetail" rows="2"
                  label="รายละเอียดที่อยู่ (บ้านเลขที่ / หมู่ / ถนน)" variant="outlined" placeholder="เช่น 123/4 หมู่ 5"
                  hide-details="auto" class="mb-2"></v-textarea>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" md="3">
                <v-autocomplete :rules="RequireRules" v-model="form.province" label="จังหวัด" :items="provinces"
                  item-title="name_th" item-value="id" variant="outlined" clearable :loading="isLoading"
                  @update:model-value="handleProvinceChange" hide-details="auto"
                  no-data-text="ไม่พบข้อมูล"></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3">
                <v-select :rules="RequireRules" v-model="form.district" label="อำเภอ/เขต" :items="districts"
                  item-title="name_th" item-value="id" :disabled="!form.province" variant="outlined" clearable
                  :loading="isLoading" @update:model-value="handleDistrictChange" hide-details="auto"
                  no-data-text="กรุณาเลือกจังหวัดก่อน"></v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-select :rules="RequireRules" v-model="form.subDistrict" label="ตำบล/แขวง" :items="subDistricts"
                  item-title="name_th" item-value="id" :disabled="!form.district" variant="outlined" clearable
                  :loading="isLoading" @update:model-value="handleSubDistrictChange" hide-details="auto"
                  no-data-text="กรุณาเลือกอำเภอก่อน"></v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field :rules="RequireRules" v-model="form.zipCode" label="รหัสไปรษณีย์" variant="outlined"
                  readonly bg-color="grey-lighten-4" hide-details="auto"></v-text-field>
              </v-col>
            </v-row>
          </div>

          <Transition name="fade" mode="out-in">
            <div v-if="reqPaymentFile" key="alumni-only-fields" class="pa-4 pa-md-6 pt-0">
              <v-divider class="my-6 border-opacity-50"></v-divider>

              <h3 class="text-subtitle-1 mb-4 font-weight-bold text-pink-darken-1">
                <v-icon start size="small">mdi-briefcase</v-icon> สถานที่ทำงาน
              </h3>
              <v-row dense>
                <v-col cols="12" md="4">
                  <v-text-field variant="outlined" label="ชื่อสถานที่ทำงาน" hide-details="auto"
                    v-model="form.jobAddress"></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field variant="outlined" label="ตำแหน่ง" hide-details="auto"
                    v-model="form.jobPosition"></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field variant="outlined" label="เบอร์โทรที่ทำงาน" hide-details="auto"
                    v-model="form.jobPhone"></v-text-field>
                </v-col>
              </v-row>
              <v-row dense="">
                <v-col cols="12" md="12" class="mt-2">
                  <v-textarea v-model="form.jobAddressDetail" :rules="lengthRule" :counter="120" maxlength="120"
                    rows="1" auto-grow label="รายละเอียดที่อยู่ ที่ทำงาน" variant="outlined"
                    hide-details="auto"></v-textarea>
                </v-col>
              </v-row>

              <v-divider class="my-6 border-opacity-50"></v-divider>

              <h3 class="text-subtitle-1 mb-4 font-weight-bold text-green-darken-1">
                <v-icon start size="small">mdi-cash-check</v-icon>
                หลักฐานการชำระเงิน
              </h3>
              <v-row class="p-4 mx-4 d-flex justify-center align-center">
                <v-col cols="12" md="6">
                  <v-img :width="auto" aspect-ratio="16/9" cover rounded="xl" class="img-box mb-4"
                    src="/alumnifee.png"></v-img>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" md="6">
                  <v-file-input accept="image/*, application/pdf" clearable label="อัปโหลดสลิป (รูป หรือ PDF)"
                    variant="outlined" v-model="form.paymentFile"></v-file-input>
                </v-col>
              </v-row>
            </div>
          </Transition>
          <v-card-actions class="pa-6 justify-end">
            <v-btn @click="goToStatus"  variant="outlined"
              class="px-6 mr-auto bg-pink-lighten-2">ลงชื่อเข้าใช้งาน</v-btn>

            <v-btn color="indigo-darken-4" variant="flat" class="px-10" @click="submitForm" :loading="isLoading"
              :disabled="!validateForm() || isLoading">
              ส่งข้อมูลการสมัคร
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, reactive, onMounted, computed, getCurrentInstance, onUnmounted, watch } from "vue";
import { useAuthStore } from "@/stores/auth";
import { onBeforeRouteLeave } from 'vue-router'
import axios from "axios";
import router from "@/router";
// Fixed: Initialize proxy properly within setup
const { proxy } = getCurrentInstance();
const isDirty = ref(false)
const authStore = useAuthStore();
const isLoading = ref(false);
const allProvincesData = ref([]);
const provinces = ref([]);
const districts = ref([]);
const subDistricts = ref([]);
const isDuplicate = ref(false);
const isChecking = ref(false);
const RequireRules = [(v) => !!v || "กรุณากรอกข้อมูลให้ครบถ้วน."];
const lengthRule = [
  (v) => (v && v.length <= 120) || 'จำกัด 120 ตัวอักษร'
]

const emailRegex = /^[\w\.-]+@(?!(ptu\.ac\.th)$)[a-zA-Z\d\.-]+\.[a-zA-Z]{2,}$/;
const emailRule = [(v) => v && emailRegex.test(v) || 'กรอกรูปแบบ Email ให้ถูกต้อง และ ไม่ใช่ Mail PTU']

const phoneAlert = ref("");
const searchQuery = reactive({
  fname: "",
  lname: "",
});

const form = reactive({
  prefix: null,
  generation: null,
  birthday: null,
  // job: "",
  contact_email: '',
  LineId: '',
  phone: "",
  addressDetail: "",
  paymentFile: null,
  studentNum: "",
  province: null,
  district: null,
  subDistrict: null,
  zipCode: "",
  jobAddress: "",
  jobPosition: "",
  jobPhone: "",
  jobAddressDetail: "",
  firstName: "",
  lastName: "",
  // fullName: form.firstName + ' '+ form.lastName,
  newName: ''
});
watch(searchQuery, () => {
  isDirty.value = true

}, { deep: true })

watch(form, () => {
  isDirty.value = true

}, { deep: true })
const handleBeforeUnload = (event) => {
  if (isDirty.value) {
    event.preventDefault() // สั่งให้ Browser หยุดก่อน!
    event.returnValue = '' // ต้องใส่ค่าว่างไว้เพื่อให้ Browser ยอมโชว์หน้าต่างเตือน
  }
}
onMounted(() => {
  window.addEventListener('beforeunload', handleBeforeUnload)
})

onUnmounted(() => {
  // ต้อง "ลบ" ออกเมื่อออกจากหน้า เพื่อไม่ให้ไปโผล่ที่หน้าอื่น
  window.removeEventListener('beforeunload', handleBeforeUnload)
})
onBeforeRouteLeave((to, from) => {
  if (isDirty.value) {
    const answer = window.confirm('คุณยังไม่ได้บันทึกข้อมูล ต้องการออกใช่ไหม?')
    if (!answer) return false // สั่งหยุดการเปลี่ยนหน้า
  }
})
const goToStatus = () => {
  router.push("/check_status");
};

const otherPrefix = ref("");
const fetchThaiAddressData = async () => {
  isLoading.value = true;
  try {
    const response = await fetch(
      "https://raw.githubusercontent.com/kongvut/thai-province-data/refs/heads/master/api/latest/province_with_district_and_sub_district.json"
    );
    const data = await response.json();
    data.sort((a, b) => (a.name_th || "").localeCompare(b.name_th || "", "th"));
    allProvincesData.value = data;
    provinces.value = data;
  } catch (error) {
    console.error("Failed to load address data:", error);
  } finally {
    isLoading.value = false;
  }
};

const handleProvinceChange = (provinceId) => {
  form.district = null;
  form.subDistrict = null;
  form.zipCode = "";
  districts.value = [];
  subDistricts.value = [];
  if (!provinceId) return;
  const selectedProvince = allProvincesData.value.find(
    (p) => p.id === provinceId
  );
  if (selectedProvince?.districts) {
    districts.value = [...selectedProvince.districts].sort((a, b) =>
      (a.name_th || "").localeCompare(b.name_th || "", "th")
    );
  }
};

const handleDistrictChange = (districtId) => {
  form.subDistrict = null;
  form.zipCode = "";
  subDistricts.value = [];
  if (!districtId) return;
  const selectedDistrict = districts.value.find((d) => d.id === districtId);
  if (selectedDistrict?.sub_districts) {
    subDistricts.value = [...selectedDistrict.sub_districts].sort((a, b) =>
      (a.name_th || "").localeCompare(b.name_th || "", "th")
    );
  }
};

const handleSubDistrictChange = (subDistrictId) => {
  if (!subDistrictId) return;
  const selectedSubDistrict = subDistricts.value.find(
    (s) => s.id === subDistrictId
  );
  if (selectedSubDistrict) form.zipCode = String(selectedSubDistrict.zip_code);
};

const customFormat = (date) => {
  if (!date) return "";
  const d = new Date(date);
  return `${String(d.getDate()).padStart(2, "0")}/${String(
    d.getMonth() + 1
  ).padStart(2, "0")}/${d.getFullYear()}`;
};

const prefixes = [
  { title: "นาย", value: "นาย" },
  { title: "นาง", value: "นาง" },
  { title: "นางสาว", value: "นางสาว" },
  { title: "ดร.", value: "ดร." },
  { title: "ผศ.", value: "ผศ." },
  { title: "ผศ. ดร.", value: "ผศ. ดร." },
  { title: "รศ.", value: "รศ." },
  { title: "รศ. ดร.", value: "รศ. ดร." },
  { title: "ศ.", value: "ศ." },
  { title: "ศ. ดร.", value: "ศ. ดร." },
  { title: "นพ.", value: "นพ." }, // Male Doctor
  { title: "พญ.", value: "พญ." }, // Female Doctor
  { title: "ทพ.", value: "ทพ." }, // Male Dentist
  { title: "ทพญ.", value: "ทพญ." }, // Female Dentist
  { title: "สพ.ญ.", value: "สพ.ญ." }, // Veterinarian

  { title: "ร.ต.ต.", value: "ร.ต.ต." },
  { title: "พล.ต.ต.", value: "พล.ต.ต." },
  { title: "พล.ต.อ.", value: "พล.ต.อ." },

  // Fallback
  { title: "อื่นๆ", value: "other" },
];

const sNumrule = [
  (v) => !isNaN(v) || "ต้องเป็นตัวเลขเท่านั้น",
  (v) => (v && (v.length === 13 || v.length === 10)) || "รหัสนักศึกษาต้องมี 10 หรือ 13 หลัก",
  (v) => !isDuplicate.value || "รหัสนักศึกษานี้ลงทะเบียนแล้ว กรุณาตรวจสอบสถานะ", // New Rule!
];

// const sType = (value) => {
//   if (
//     form.studentNum &&
//     form.studentNum.length === 13 &&
//     !isNaN(form.studentNum)
//   ) {
//     if (!value || value.length < 2) return false;
//     const currentYearPrefix = String(new Date().getFullYear() + 543).slice(-2);
//     const studentYearPrefix = value.slice(0, 2);
//     return Number(studentYearPrefix) < Number(currentYearPrefix) - 4;
//   } else {
//     return false;
//   }
// };

const sType = (value) => {
  if (value && (value.length === 13 || value.length === 10) && !isNaN(value)) {
    const entryYearShort = Number(value.slice(0, 2));
    const currentThaiYear = new Date().getFullYear() + 543;
    
    // Future-proof: Determine the full entry year using a sliding window
    const century = Math.floor(currentThaiYear / 100) * 100;
    let entryYearFull = century + entryYearShort;
    
    // If the calculated year is somehow in the future, they must have enrolled in the previous century
    if (entryYearFull > currentThaiYear + 1) {
      entryYearFull -= 100;
    }

    const yearsInSystem = currentThaiYear - entryYearFull;

    // If they have been here 4 years or more, they are Alumni and must pay
    return yearsInSystem >= 4;
  }
  return false;
};

const reqPaymentFile = computed(() => sType(form.studentNum));

const validateForm = () => {
  if (!form.studentNum || (form.studentNum.length !== 13 && form.studentNum.length !== 10) || isDuplicate.value) return false;

  const hasBaseInfo =
    form.contact_email &&
    form.birthday &&
    form.phone &&
    form.addressDetail &&
    form.province &&
    form.district &&
    form.subDistrict;

  if (!hasBaseInfo || !emailRegex.test(form.contact_email)) return false;

  // 3. Conditional Alumni fields
  if (reqPaymentFile.value) {
    const hasJobInfo = form.jobAddress && form.jobPosition && form.jobPhone && form.jobAddressDetail;
    const hasPayment = !!form.paymentFile;
    return hasJobInfo && hasPayment;
  }

  return true;
};
const phoneAlertMessage = (phone) => {
  // Regex Explanation:
  // ^0    = Must start with 0
  // [689] = Next digit must be 6, 8, or 9
  // [0-9] = Followed by any digit 0-9
  // {8}   = Exactly 8 times (making total 10 digits)
  const mobileRegex = /^0[689][0-9]{8}$/;

  if (!mobileRegex.test(phone)) {
    // Determine specific error for better UX
    if (phone.length !== 10) {
      return "เบอร์โทรต้องมี 10 หลัก";
    }
    if (!["06", "08", "09"].includes(phone.substring(0, 2))) {
      return "เบอร์โทรศัพท์มือถือต้องขึ้นต้นด้วย 06, 08 หรือ 09";
    }
    return "เบอร์โทรต้องเป็นตัวเลขเท่านั้น";
  }

  return "";
};
const checkDuplicate = async () => {
  // Only check if the ID is valid (10 or 13 chars)
  if (!form.studentNum || (form.studentNum.length !== 13 && form.studentNum.length !== 10)) return;

  isChecking.value = true;
  try {
    // Call the new backend route you just pasted
    const response = await axios.post("/api/check-duplicate", {
      studentNum: form.studentNum,
    });

    if (response.data.exists) {
      isDuplicate.value = true;
      isDirty.value = false; 
      // Optional: Show a toast warning
      proxy
        .$swal({
          icon: "warning",
          title: `รหัสนักศึกษา ${form.studentNum} นี้มีในระบบแล้ว`,
          text: 'คุณสามารถตรวจสอบสถานะได้ที่เมนู "ตรวจสอบสถานะ"',
          // timer: 5000, // Suggestion: Remove timer if you want them to read and click
          showConfirmButton: true,
          confirmButtonText: '<span style="color:white">ไปตรวจสอบสถานะ</span>',
          // confirmButtonText: "ไปตรวจสอบสถานะ", // Make the button clear
          // showCancelButton: true, // Give them a choice to stay
          // cancelButtonText: "ปิด",
          confirmButtonColor: "#3085d6",
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        .then((result) => {
          // This runs AFTER the user clicks a button or the timer ends
          if (result.isConfirmed) {
            // Run your redirect logic here
            router.push("/check_status");
          }
        });
    } 
    else {
      isDuplicate.value = false;
    }
  } catch (error) {
    console.error("Check duplicate failed:", error);
  } finally {
    isChecking.value = false;
  }
};
const canSearch = computed(() => {
  if (searchQuery.fname && searchQuery.lname) {
    return true;
  } else false;
});
const checkName = async () => {
  // isLoading.value = true;

  if (!canSearch) {
    return alert("no!");
  }

  try {
    console.log(searchQuery.fname, "and", searchQuery.lname);
    const response = await axios.get("/api/check_name", {
      params: searchQuery,
      validateStatus: function (status) {
        return (
          (status >= 200 && status < 300) ||
          status === 400 ||
          status === 404 ||
          status === 401
        );
      },
    });

    if (response.status === 200) {
      form.studentNum = response.data.data.studentNum;
      form.firstName = response.data.data.firstName;
      form.lastName = response.data.data.lastName;
      await checkDuplicate()
      if(isDuplicate.value == false){
        proxy.$swal({
        title: "ค้นพบนักศึกษา",
        text: `ยินดีต้อนรับ ${form.firstName} ${form.lastName}`,
        icon: "success",
        timer: 3000,
        customClass: {
          container: "my-swal-container",
          title: 'text-primary font-weight-bold',
          htmlContainer: 'text-grey-darken-1',
          confirmButton: "bg-green text-white px-6 py-2 rounded shadow-lg", // Apply a custom class to the main SweetAlert container
        },
      });
      }
     
    } else if (response.status === 400) {

      proxy.$swal({
        title: "ล้มเหลว",
        text: response.data.message,
        icon: "error",
        timer: 3000,
        customClass: {
          container: "my-swal-container",
          title: ' font-weight-bold',
          htmlContainer: 'text-black-darken-1',
          confirmButton: "bg-red text-white px-6 py-2 rounded shadow-lg",// Apply a custom class to the main SweetAlert container
        },
      });
    }

  } catch (err) {
    console.log(err);
  } finally {
    // checkDuplicate()
  }

};
const changeName = ref(false)

const clearSearch = () => {
  searchQuery.fname = ''
  searchQuery.lname = ''
  form.studentNum = ''
  form.firstName = ''
  form.lastName = ''
}


const submitForm = async () => {
  isLoading.value = true;
  const data = new FormData();
  form.fullName = `${form.firstName} ${form.lastName}`

  // if (form.prefix === "other") {
  //   data.append("prefix", otherPrefix.value || "");
  // } else {
  //   data.append("prefix", form.prefix || "");
  // }

  // Mapping logic
  Object.keys(form).forEach((key) => {
    if (key !== "paymentFile" && key !== "prefix") {
      // FIX: Format Date before sending
      if (key === "birthday" && form[key]) {
        const d = new Date(form[key]);
        // Formats to YYYY-MM-DD (Standard for Databases)
        const dateString = d.toISOString().split("T")[0];
        data.append(key, dateString);
      }
      // Normal fields
      else {
        data.append(key, form[key] || "");
      }
    }
  });

  // Append Address Names for Google Sheets
  data.append(
    "provinceName",
    provinces.value.find((p) => p.id === form.province)?.name_th || ""
  );
  data.append(
    "districtName",
    districts.value.find((d) => d.id === form.district)?.name_th || ""
  );
  data.append(
    "subDistrictName",
    subDistricts.value.find((s) => s.id === form.subDistrict)?.name_th || ""
  );
  data.append(
    'fullname',
    form.firstName + ' ' + form.lastName || ""
  )

  if (form.paymentFile) {
    const file = Array.isArray(form.paymentFile)
      ? form.paymentFile[0]
      : form.paymentFile;
    data.append("paymentSlip", file);
  }

  try {
    proxy.$swal({
    title: "กำลังส่งข้อมูล...",
    allowOutsideClick: false, // Prevents clicking the background to close
    allowEscapeKey: false,    // Prevents ESC key from closing it
    showConfirmButton: false, // Hide the OK button
    didOpen: () => {
      proxy.$swal.showLoading();
    },
  });
    const response = await axios.post("/api/Alumni_register", data);
    if (response.status === 200) {
      proxy.$swal({
        title: "สำเร็จ!",
        text: "ส่งข้อมูลเรียบร้อย",
        icon: "success",
        timer: 2000,
      });
      isDirty.value = false; // Reset dirty state after successful submission
      router.push("/check_status"); //turn off for debug
    }
  } catch (error) {
    proxy.$swal({ title: "ผิดพลาด", text: error.message, icon: "error" });
  } finally {
    isLoading.value = false;
  }
};




onMounted(() => {
  fetchThaiAddressData();
  setTimeout(() => {
    isDirty.value = false;
    console.log("System Ready: isDirty reset to false");
  }, 500); // ให้เวลามันนิ่งสักครู่

  window.addEventListener('beforeunload', handleBeforeUnload);
});
</script>

<style scoped>
.my-confirm-button {
  color: #ffffff !important; /* Your text color */
}
.img-box {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease, transform 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* 1. Aligns the checkbox and label to the top */
:deep(.v-selection-control) {
  align-items: flex-start !important;
}

/* 2. Forces the label to sit tight against the checkbox instead of stretching */
:deep(.v-label) {
  justify-content: flex-start !important;
  flex: none !important;
  opacity: 1;
  /* Ensures Thai text stays clear */
  padding-inline-start: 2px;
  /* Space between box and text */
}

/* 3. Removes default margins that might push it right */
:deep(.v-selection-control__wrapper) {
  margin-inline-start: 0 !important;
}
</style>
